'use strict';

/* global $ */

import { getAjax } from '../utils/ajax';
import { fancybox } from '../utils/params';

/**
 *  Обработчик для создания галерей
 */
function GalleryPopup(options){
    var opt = $.extend({
        selector: '.js-popup-image',
        linkSelector: '.js-popup-gallery',
        fancy: {
            fitToView: true,
            helpers:  {
                thumbs : {
                    width: 50,
                    height: 50
                }
            }
        }
    }, options);

    $(opt.selector).fancybox($.extend(true, {}, fancybox, opt.fancy));

    $(opt.linkSelector).on('click', function() {
        let $el = $(this);

        if (!$el.data('gallery')) {
            let data = $.extend({}, {
                _do: 'get_gallery',
                result: 'json'
            }, $el.data());

            getAjax(data, { url: '/json/' })
            .then(function(response) {
                $el.data('gallery', response.data);
                showGallery(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
        } else {
            showGallery($el.data('gallery'));
        }

        return false;
    });

    function showGallery(data) {
        $.fancybox.open(data, $.extend(true, {}, fancybox, opt.fancy));
    }
}

export {
    GalleryPopup
};

